import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ShortcutsNotificationsService {
  constructor(private apiService: ApiService) {
  }

  public getShortCutsNotifications(): Observable<IShortcutNotification[]> {
    return this.apiService.getShortCutsNotifications();
  }
}

export interface IShortcutNotification {
  shortcutType: string;
  notification: {
    counter: number
  };
}

export interface IUpdateGiftNotifications {
  notificationCounter: number;
}
